
const URL = {
  //本地开发的路径配置

  //测试服务器环境的路径配置
  serviceTestSit: {
      // baseUrl: 'http://testfund.biyouxinjr.com:8099/', //金融代收代付测试地址
      baseUrl: 'https://parent.brightscholar.net/', //金融代收代付测试地址
      // baseUrl: 'http://localhost:8080/', //金融代收代付测试地址


  },

  //服务器环境的路径配置
  service: {
      baseUrl: 'https://parent.brightscholar.com/',  //金融代收代付生产地址

  },

}
export default URL



// WEBPACK FOOTER //
// ./src/data/api.js